module.exports = __webpack_public_path__ + "img/headshot-gina-papalia@2x.5ed8ee36.jpg";